<template>
  <div class="item position-rel">
    <div class="item__head aspect-ratio aspect-ratio--16-9">
      <div class="item__head__img">
        <img 
          v-if="dataSource.linkUrl && checkImage(dataSource.linkUrl)"
          :src="`${bookCdnUrl}${dataSource.linkUrl}`"
          :alt="dataSource.title"
        >
        <img 
          v-if="dataSource.posterLink && (checkVideo(dataSource.linkUrl) || checkAudio(dataSource.linkUrl))"
          :src="`${urlCMS}/${dataSource.posterLink}`"
          :alt="dataSource.title"
        >
      </div>
      <a href="javascript:;" class="item__viewer" @click="handleViewMedia(dataSource, position)"><i class="icon-eye color-light"></i></a>
    </div>
    <div class="item__body" @click="handleAddMedia(dataSource)">
      <!-- <div class="item__body__top display-flex-center justify-content-between full-width">
        <div class="item__time">03:00</div>
      </div> -->
      <h4 class="item__name">
        {{ dataSource.title }}
      </h4>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { APP_CONFIG } from '@/utils/constants'
import mixinsDetailLesson from './../../_store/mixinsDetailLesson'
import { MEDIA_TYPE_IMG, MEDIA_TYPE_VIDEO, MEDIA_TYPE_AUDIO, STORE_KEY } from './../../_store/constants'
import mixinsFiles from '@/components/content-files/mixinsFiles'

export default {
  name: 'ItemDataAction',
  mixins: [ mixinsDetailLesson, mixinsFiles ],
  props: {
    dataSource: Object,
    position: Number
  },
  data () {
    return {
      bookCdnUrl: APP_CONFIG.bookCdnUrl,
      urlCMS: APP_CONFIG.urlPlatformCmsImg
    }
  },
  methods: {
    ...mapActions(STORE_KEY,  ['acSetPreviewModalVisibleIndex']),

    handleAddMedia (data) {
      let self = this

      if (data && data.linkUrl && this.checkImage(data.linkUrl)) {
        this.addImageUrl(`${this.bookCdnUrl}${data.linkUrl}`)
      } else if ( data && data.linkUrl && this.checkAudio(data.linkUrl) ) {
        this.addAudio(data)
      } else if (data && data.linkUrl && this.checkVideo(data.linkUrl)) {
        this.addVideo(data)
      }
    },

    handleViewMedia (data, index) {
      this.acSetPreviewModalVisibleIndex(index)
      // console.log('Handle View media: ', data);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>